export const DELIVERY_CHANGE_REASONS = [
    {
        id: 'unintentionalChangeTiempo',
        value: 'tiempoentrega-UNINTENTIONAL_CHANGE',
        label: 'Tiempo de entrega',
    },
    {
        id: 'unintentionalChangeAcuerdo',
        value: 'acuerdo-UNINTENTIONAL_CHANGE',
        label: 'Acuerdo entre repartidores',
    },
    {
        id: 'unintentionalChangeRuta',
        value: 'ruta-UNINTENTIONAL_CHANGE',
        label: 'Beneficio de ruta',
    },
    {
        id: 'intentionalChange',
        value: 'sinmotivo-INTENTIONAL_CHANGE',
        label: 'Sin motivo / acuerdo',
    },
];
